import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19.063" height="19.507" fill="#4972d2">
    <path d="M17.368 16.906a.854.854 0 01-.847.867H2.542a.854.854 0 01-.847-.867V2.6a.854.854 0 01.847-.867h5.507V0H2.542A2.561 2.561 0 000 2.6v14.3a2.561 2.561 0 002.542 2.6h13.979a2.561 2.561 0 002.542-2.6v-5.629h-1.695z" />
    <path d="M11.014 0v1.734h5.154l-6.66 6.815 1.2 1.228 6.66-6.815v5.274h1.694V0z" />
  </svg>
);
